import { render, staticRenderFns } from "./Screenshots.vue?vue&type=template&id=425e9d05&scoped=true&"
import script from "./Screenshots.vue?vue&type=script&lang=js&"
export * from "./Screenshots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425e9d05",
  null
  
)

export default component.exports